import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';

import { ControllerProps } from 'src/router';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { PaymentListDataService } from './payment-list.data';
import { PaymentListView } from './payment-list.view';

interface Props extends ControllerProps<{}> {
	type: 'agent' | 'client' | 'supplier';
}

export class PaymentListController extends React.Component<Props, {}> {
	@resolve
	toast: ToastNotifications;

	@observable
	dataService: PaymentListDataService;

	constructor(props: Readonly<Props>) {
		super(props);
	}

	componentDidMount(): void {
		this.props.setBusy(true);

		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private get accountingTarget(): number {
		const { type } = this.props;
		switch (type) {
			case 'client':
				return 1;
			case 'agent':
				return 2;
			case 'supplier':
				return 4;
			default:
				return 0;
		}
	}

	private async loadData(): Promise<void> {
		this.dataService = PaymentListDataService.make();

		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.addFilter('accountingTarget', 'eq', this.accountingTarget);
		this.dataService.pageSize = 10;

		await this.dataService.load(query => query);
	}

	render(): React.ReactNode {
		if (this.dataService == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<div className="panel">
					<PaymentListView
						model={this.dataService}
						setBusy={this.props.setBusy}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/shared/payments/list/payment-list.controller.tsx